import Logger from "../../../utils/Logger";
import FrameCollectionDispatcher from "./FrameCollectionDispatcher";
const TAG = 'DispatchFrameCollectionManagerUtils';
export default class DispatchFrameCollectionManagerUtils {
    static locationChange(message) {
        const topLevelIframe = window.frames ? window.frames[0] : null;
        if (topLevelIframe) {
            Logger.debug(TAG, "Dispatch location change to top level iframe");
            FrameCollectionDispatcher.dispatchMessage(topLevelIframe, message.type, message);
        }
    }
}
//# sourceMappingURL=DispatchFrameCollectionManagerUtils.js.map